import React, { Component } from 'react'
import styled from 'styled-components'
import { Tabs } from 'antd'
import FromRegister from '../components/FromRegister'
import FinishFrom from '../components/FinishFrom'
import FormCondition from '../components/Condition'

const TabPane = Tabs.TabPane
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  width: 100%;
  height: 100vh;
`
const StopTop = styled.div`
  position: relative;
  width: 100%;
  top: 1rem;
  text-align: center;
  padding: 0 1rem 0 1rem;
`
class PageRegister extends Component {
  state = {
    tab: '1'
  }
  componentDidMount() {
    document.title = 'ลงทะเบียนวันนี้...รับสิทธิ์แลกซื้อไก่คารา คารา ชิคเก้น'
  }
  SelectPage = page => {
    this.setState({ tab: page })
  }
  render() {
    const { tab } = this.state
    return (
      <Container>
        <StopTop>
          <Tabs activeKey={tab}>
            <TabPane tab="เงื่อนไข" key="1">
              <FormCondition SelectPage={this.SelectPage} />
            </TabPane>
            <TabPane tab="ลงทะเบียน" key="2">
              <FromRegister SelectPage={this.SelectPage} />
            </TabPane>
            <TabPane tab="เสร็จสิ้น" key="3">
              <FinishFrom />
            </TabPane>
          </Tabs>
        </StopTop>
      </Container>
    )
  }
}

export default PageRegister
